import { render } from "./TitleSection.vue?vue&type=template&id=2c781a6e"
import script from "./TitleSection.vue?vue&type=script&lang=js"
export * from "./TitleSection.vue?vue&type=script&lang=js"

import "./TitleSection.vue?vue&type=style&index=0&id=2c781a6e&lang=scss"

import exportComponent from "/home/vitsuji/Projects/iGEM-Wiki/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__